import React from "react";

const MasInfo = () => {
  return (
    <div>
      <h3>Más información sobre los métodos.</h3>
      <p>
        Si quieres saber un poco más sobre los métodos para calcular &pi; te
        invito a que leas{" "}
        <a href="https://linuxmanr4.com/2023/09/07/como-calcular-pi-con-python-metodos-y-ejemplos/">
          Cómo calcular Pi con Python: métodos y ejemplos
        </a>
        .
      </p>
    </div>
  );
};

export default MasInfo;
